import Error from "@/http/data/error-data";
import Session from "@/http/data/session-data";

export default class UserState {
    isInitialized = false;
    loginError: null|Error = null;
    requestInProgress = false;
    session: null|Session = null;
}